import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {AddToBasketPayload} from '../../../features/ProductStream/Tiles/StreamProductTileDeprecated';
import {RecommendationsSkeleton} from '../Recommendations/Recommendations.skeleton';
import {useComplementaryRecommendation} from '../hooks/useGetBasketPageSection';
import {ComplementaryRecommendationView} from './ComplementaryRecommendationView';

export interface ComplementaryRecommendationProps {
  onClickAddToBasket: (productTile: AddToBasketPayload | undefined) => void;
  smallerPaddings?: boolean;
  showNavigation?: boolean;
  isSmallFormat?: boolean;
}

export const ComplementaryRecommendation = ({
  onClickAddToBasket,
  smallerPaddings,
  showNavigation,
  isSmallFormat,
}: ComplementaryRecommendationProps) => {
  return (
    <>
      <DataFetcher
        request={useComplementaryRecommendation()}
        Error={() => null}
        View={ComplementaryRecommendationView}
        disableLoadingInIdleState
        Loading={RecommendationsSkeleton}
        viewProps={{
          onClickAddToBasket,
          smallerPaddings,
          showNavigation,
          isSmallFormat,
        }}
      />
    </>
  );
};
